import { render } from "./DashboardBlogBox.vue?vue&type=template&id=9dea21a8"
import script from "./DashboardBlogBox.vue?vue&type=script&lang=js"
export * from "./DashboardBlogBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/DashboardBlogBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9dea21a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9dea21a8', __exports__)) {
    api.reload('9dea21a8', __exports__)
  }
  
  module.hot.accept("./DashboardBlogBox.vue?vue&type=template&id=9dea21a8", () => {
    api.rerender('9dea21a8', render)
  })

}


export default __exports__